// Translations
import form from '../sections/form/translations/ua'

// Translation: Terms of service > Landing (Ukrainian)
export default Object.freeze({
	sections: { form }
})
